import { Box } from '@mui/material';
import { Container } from '@mui/system';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useAuthenticated, useCases, useMe, useShifts, useUpdateAuthentication } from './api';
import Error from './components/Error';
import Inactive from './components/Inactive';
import Login from './components/Login';
import { Shyftr } from './components/Shyftr';
import Spinner from './components/Spinner';

const appStyle = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'scroll',
};
const containerStyle = { height: 'inherit', padding: 0 };

const App = () => {
  const { isError: casesError, isLoading: casesLoading, isSuccess: casesSuccess } = useCases();
  const { data: me, isError: meError, isLoading: meLoading, isSuccess: meSuccess } = useMe();
  const { isError: shiftsError, isLoading: shiftsLoading, isSuccess: shiftsSuccess } = useShifts();
  const [searchParams, setSearchParams] = useSearchParams();
  const { data: isAuthenticated } = useAuthenticated();
  const { mutate: authenticate } = useUpdateAuthentication();
  const tokenParam = searchParams.get('token');
  const [isFilterOn] = useState(() => searchParams.get('isFilterOn') === 'true');
  const isError = casesError || meError || shiftsError;
  const isLoading = casesLoading || meLoading || shiftsLoading;
  const isSuccess = casesSuccess && meSuccess && shiftsSuccess;

  useEffect(() => {
    if (tokenParam) {
      authenticate(tokenParam);
      setSearchParams({}, { replace: true });
    }
  }, [authenticate, setSearchParams, tokenParam]);

  return (
    <Box sx={appStyle}>
      <Container maxWidth="sm" sx={containerStyle}>
        {!isAuthenticated && <Login />}
        {isAuthenticated && isLoading && <Spinner />}
        {isAuthenticated && isError && <Error />}
        {isAuthenticated && isLoading === false && meSuccess && !me.active && <Inactive />}
        {isAuthenticated && isSuccess && me.active && <Shyftr isFilterOn={isFilterOn} />}
      </Container>
    </Box>
  );
};

export default App;
